
export const ADMIN_OFFRES_INITIATE_FETCH_LISTE_OFFRES = 'ADMIN_OFFRES_INITIATE_FETCH_LISTE_OFFRES';
export const ADMIN_OFFRES_FETCH_LISTE_OFFRES_START = 'ADMIN_OFFRES_FETCH_LISTE_OFFRES_START';
export const ADMIN_OFFRES_FETCH_LISTE_OFFRES_SUCCESS = 'ADMIN_OFFRES_FETCH_LISTE_OFFRES_SUCCESS';
export const ADMIN_OFFRES_FETCH_LISTE_OFFRES_FAIL = 'ADMIN_OFFRES_FETCH_LISTE_OFFRES_FAIL';
export const ADMIN_OFFRES_FETCH_LISTE_OFFRES_RESET = 'ADMIN_OFFRES_FETCH_LISTE_OFFRES_RESET';